import Swiper from "swiper";
import { Navigation, EffectFade, Autoplay } from 'swiper/modules';

const rendingResourcesCarousel = document.querySelectorAll(".customer-stories-featured-carousel");

rendingResourcesCarousel.forEach((slider, index) => {
    const Carousel = slider.querySelector(".swiper");
    const prevArrow = slider.querySelector(".swiper-button-prev");
    const nextArrow = slider.querySelector(".swiper-button-next");

    const mainSwiper = new Swiper(Carousel, {
        modules: [Navigation, EffectFade],
        slidesPerView: 1,
        centerInsufficientSlides: true,
        spaceBetween: 0,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: true,
        navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
        },
    });

    const nestedSliders = slider.querySelectorAll(".swiper-slide .facts .swiper");

    if (nestedSliders.length > 0) {
        nestedSliders.forEach((nestedSlider) => {
            new Swiper(nestedSlider, {
                modules: [EffectFade, Autoplay],
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false
                },
                speed: 1000,
                loop: true
            });
        });
    }
});
